export const ActivityTypes = {
  TabletActions: 'tablet_actions',
  Create: 'create',
  Delete: 'delete',
  Modify: 'modify',
  Alert: 'alert',
  Error: 'error',
  Warning: 'warning',
  Connect: 'connect',
  Disconnect: 'disconnect',
};
